import { render, staticRenderFns } from "./TranslationUploadBatchForm.vue?vue&type=template&id=b596f1f2"
import script from "./TranslationUploadBatchForm.vue?vue&type=script&lang=js"
export * from "./TranslationUploadBatchForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports